const $ = require('jquery')

// =========================================================================
// Booking widget
// =========================================================================
const bookingWidget = {
  init () {
    const elemBookingWidget = $('.form-booking')
    const elemBookingWidgetFooter = $('.offer-sidebar__footer')

    if (elemBookingWidgetFooter.exists()) {
      const getUrl = window.location
      const href = `mailto:?body=${getUrl}`
      elemBookingWidgetFooter.find('.js-mailto').attr('href', href)
    }

    $('#open-food').on('click', function() {
      elemBookingWidget
        .find('.custom-select-food .section-title')
        .attr('data-toggle', 'dropdown')
        .addClass('dropdown-toggle')

      setTimeout(function() {
        elemBookingWidget
          .find('.custom-select-food .section-title')
          .dropdown()

        elemBookingWidget
          .find('.custom-select-food')
          .addClass('open')
      }, 50)
    })
    $('#open-rooms').on('click', function() {
      elemBookingWidget
        .find('.custom-select-room .section-title')
        .attr('data-toggle', 'dropdown')
        .addClass('dropdown-toggle')

      setTimeout(function() {
        elemBookingWidget
          .find('.custom-select-room .section-title')
          .dropdown()

        elemBookingWidget
          .find('.custom-select-room')
          .addClass('open')
      }, 50)
    })
  },
}

module.exports = bookingWidget



// WEBPACK FOOTER //
// ./src/modules/bookingWidget.js